import { createFileRoute } from '@tanstack/react-router';

import { getTranslationOptions } from '@/module/Author/Translation';

export const Route = createFileRoute('/_auth/author/_author/translation/_translation/$translationId/_layout')({
  loader: async ({ params: { translationId }, context: { queryClient } }) => {
    const translation = await queryClient.ensureQueryData(getTranslationOptions(translationId));

    return {
      translation,
      crumb: translation.title,
    };
  },
});
